import React, { useState, useEffect } from 'react';
import { Dialog } from 'cdk-radial';

import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    MaskableFormattedInput,
    Loader,
    Column, Grid, Row,
    Toast,
    TOAST_VISIBILITY_DURATIONS,
    TextButton,DropdownMenu
} from 'cdk-radial';
import { AiFillBank } from 'react-icons/ai';
import _ from 'lodash';
import {
    setAccountContext,
    verifyBankAccount,
    setMultiDepositsContext
} from '../../../redux/connectedComponent/verifyAccount/verifyAccount.slice';
import {
    setMultiDeposits
} from '../../../redux/connectedComponent/verifyAccount/multiDeposit.slice';
import './verifyAccount.scss'

const VerifyAccount = ({
    solutionId,
    orgId,
    customerRef,
    open,
    setIsVerifyAccDialogOpen
}) => {
    const dispatch = useDispatch();
    const state = useSelector(state => state);
    const {
        loginDetailsSlice,
        verifyAccountSlice
    } = state;
    const { paymentSettings } = state.paymentSettingsSlice;
    const {paymentSettingData}=paymentSettings
    const [formData, updateFormData] = useState({
        last4:'XXXX',
        microDeposit1: 0,
        microDeposit2: 0
    });

    const [isMicroDepositDialogOpen, setIsMicroDepositDialogOpen] = useState(false);

    const [formError, setFormError] = useState({});


    // eslint-disable-next-line react-hooks/exhaustive-deps
    let solutionAccountInfo = verifyAccountSlice[solutionId] || {}

    useEffect(() => {
        dispatch(
            setAccountContext({
                solutionId
            })
        );
    }, []);

    useEffect(()=>{
        setIsMicroDepositDialogOpen(open)
    },[open])

    useEffect(() => {
        if (solutionAccountInfo.status && isMicroDepositDialogOpen) {
            setIsVerifyAccDialogOpen(false)
             dispatch(setMultiDeposits({solutionId,last4:formData.last4}))
        }
        if(solutionAccountInfo.isFailedToVerifyAccount){
            const formErrorValues={}
             _.map(formData, (value, key) => {
                formErrorValues[key] =
                    'Please enter value';
        });
            setFormError(formErrorValues)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMicroDepositDialogOpen, solutionAccountInfo]);

    const handleChange = e => {
        // line no 73 - e.target.value.split('.')
        // as we are using masked input
        // so $0. is masked so we are spliting here to get only decimal
        updateFormData({
            ...formData,
            [e.target.name]: e.target.value && e.target.value.split('.')[1].trim()
        });
        setFormError({
            ...formError,
            [e.target.name]: null
        });
    };

    const checkIsFormValid = () => {
        let isFormValid = true,
            formErrorValues = {};

        _.map(formData, (value, key) => {
            if (!value) {
                isFormValid = false;
                formErrorValues[key] =
                    'Please enter value';
            }
            if(key ==='last4' && value==='XXXX'){
                 isFormValid = false;
                formErrorValues[key] =
                    'Please select value';
            }
        });
        return { isFormValid, formErrorValues };
    };

    const handlFormSubmit = async e => {
        e.preventDefault();
        let { isFormValid, formErrorValues } = checkIsFormValid(formData);
        if (isFormValid) {
            dispatch(
                verifyBankAccount({
                    solutionId,
                    orgId,
                    customerRef,
                    ...formData,
                    token: loginDetailsSlice.authenticationToken,
                })
            );
            dispatch(setMultiDepositsContext({solutionId,last4:formData.last4}))
        } else {
            setFormError(formErrorValues);
        }
        return false;
    };
    const accountSelectionHandler=(e)=>{
         updateFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setFormError({
            ...formError,
            [e.target.name]: null
        });
    }

    return (
        <div className="verify-account">
            {/* <TextButton
             text="Verify Account"
             onClick={() => setIsMicroDepositDialogOpen(true)}
            /> */}

            <Dialog id="dialog-micro_deposit"
              isOpen={isMicroDepositDialogOpen}
              onClose={() => setIsVerifyAccDialogOpen(false)}
              title="Verify Bank Account">
                <Grid >
                    <Row>
                        Please select the account last4 digit which you want to verify.
                    </Row>
                    <Row>
                           <DropdownMenu
                                required
                                enableCustomValidation
                                hasError={formError.last4}
                                isDisabled={false}
                                label="Select Last4 Digit of ACH"
                                className={'verify-ach-account-dropdown'}
                                value={{ value: `XXXX-XXXX-XXXX-${formData.last4}`,
                                  label: `XXXX-XXXX-XXXX-${formData.last4}`
                                  }}
                                onChange={({ value }) => {
                                    accountSelectionHandler({ target: { name: 'last4', value } })
                                }}
                                options={paymentSettingData
                                  .filter(x=>x.payment_type==='stripe_bank' && !x.status)
                                  .map(type => ( { value: type.last4, label: type.last4,icon:<AiFillBank/>}))}>
                            </DropdownMenu>
                    </Row>
                    <Row>
                        <Column l={12}
                            xs={12}><div className="micro_deposit_label_text">Enter the two amounts that were deposited into your account.</div></Column>
                    </Row>
                     {
                      !solutionAccountInfo.isFailedToVerifyAccount && renderInputsRow(formError,formData,handleChange)
                     }
                     {
                        solutionAccountInfo.isFailedToVerifyAccount && renderInputsRow(formError,formData,handleChange)
                     }
                    {solutionAccountInfo.isFailedToVerifyAccount &&
                      <Row>
                        <Toast
                          content={'The amount entered do not match the amounts that were deposited.'}
                          variant={'negative'}
                          style={{ padding: '0px 10px 5px 0px' }}
                          visibilityDuration={TOAST_VISIBILITY_DURATIONS.SEVEN_SECONDS}/>
                       </Row>
                    }
                    {solutionAccountInfo.isLoadingToVerifyAccount && <Row>
                        <div className='verify_account_actions'>
                        <Loader
                            data-testid="loader"
                            hideLabel={false}
                            label="Loading..."
                            spinnerClassName=""
                            variant="inline"
                        />
                        </div>
                    </Row>}
                    {!solutionAccountInfo.isLoadingToVerifyAccount && <Row>
                        <div className='verify_account_actions'>
                            <Button
                                className="verify_button"
                                onClick={handlFormSubmit}
                                text='Verify'
                            />
                        </div>
                    </Row>}
                </Grid>
            </Dialog>
        </div>
    )


}
const renderInputsRow=(formError,formData,handleChange)=>{
        return (<Row>
                        <Column
                            l={6}
                            xs={6}>
                            <div className="micro_deposit_inlineInput-left">
                                <MaskableFormattedInput
                                    required
                                    enableCustomValidation
                                    hasError={formError.microDeposit1}
                                    label="Deposit-1"
                                    name="microDeposit1"
                                    fullWidth
                                    value={formData.microDeposit1 || ''}
                                    onChange={handleChange}
                                    mask="$0.##"
                                />
                            </div>
                        </Column>
                        <Column
                            l={6}
                            xs={6}>
                            <div className="micro_deposit_inlineInput-right">
                                <MaskableFormattedInput
                                    required
                                    enableCustomValidation
                                    hasError={formError.microDeposit2}
                                    label="Deposit-2"
                                    name="microDeposit2"
                                    fullWidth
                                    value={formData.microDeposit2 || ''}
                                    onChange={handleChange}
                                    mask="$0.##"
                                />
                            </div>
                        </Column>
                    </Row>)
    }




export default VerifyAccount
